import React from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";

export default function ForPatients() {
  return (
    <div className="cm-container py-14">
      <div className="max-w-3xl">
        <div className="cm-eyebrow mb-2">For Patients</div>
        <h1 className="cm-h2">Healthcare that starts with understanding you.</h1>
        <p className="cm-body mt-3">No more Googling symptoms. Answer a few questions and we'll guide you to the right verified doctor &mdash; general or specialist. Video-first, prescription-ready, and remembered by your Care Passport.</p>
      </div>
      <ul className="mt-8 grid md:grid-cols-2 gap-3 text-sm text-[#475569] max-w-3xl">
        {["Plain-English intake, no medical jargon","Verified doctors, transparent pricing","Care Passport keeps every note in one place","Follow-up with the same doctor","Encrypted video and messaging","Refunds for cancellations up to 24h before"].map(s => (
          <li key={s} className="cm-card flex items-start gap-2"><Check size={16} className="text-[#3daa6e] mt-0.5"/>{s}</li>
        ))}
      </ul>
      <div className="mt-10">
        <Link to="/register" className="cm-btn-primary" data-testid="fp-signup-cta">Create a free account</Link>
      </div>
    </div>
  );
}
